import {Pipe} from "./Pipe";

export class Step {
    constructor({
                    //attributes
                    id= null,
                    order= null,
                    stepable_id= null,
                    stepable_type= "App\\Models\\Step",
                    title= '',
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    //relations
                    stepable=null,
                } = {}) {

        //fill attributes
        this.id=id;
        this.order=order;
        this.stepable_id=stepable_id;
        this.stepable_type=stepable_type;
        this.title=title;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

        this.stepable=stepable;

    }

    get step(){
        if(!!this.stepable && this.stepable_type==="App\\Models\\Step")
            return createStep(this.stepable);
        else
            return null;
    }

    get pipe(){
        if(this.stepable){
            if(this.isPipeChildren())
                return this.stepable;
            else
                return this.step.pipe
        }
        else return new Pipe({});
    }

    isPipeChildren(){
        return this.stepable_type==="App\\Models\\Pipe"
    }

    isStepChildren(){
        return this.stepable_type==="App\\Models\\Step"
    }

    isUnderNegotiation(){
        return !this.step || this.step.title === "Em negociação";
    }

    isSaleMade(){
        return this.step && this.step.title === "Venda Realizada";
    }

    isSaleLost(){
        return this.step && this.step.title === "Venda Cancelada";
    }

    get parent_name(){
        if(this.step && this.isStepChildren())
            return this.step.title
        else
            return ""
    }

    get pipe_name(){
        if(this.isPipeChildren()&&this.pipe)
            return this.pipe.title
        else if(this.step && this.isStepChildren() && this.step.pipe)
            return this.step.pipe.title
        else
            return ""
    }
}

export function createStep(data={}) {
    return Object.freeze(new Step(data));
}